module.exports = __webpack_public_path__ + "img/project-edu-05.37bc425e.png";